module.exports = __webpack_public_path__ + "img/graph-paper-notebook_B09BGM11YQ.920eefe5.jpg";